import { baseAPI } from "../../../baseApi";
import { tagsTypes } from "../../../tagsTypes";

export const productContentSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Save product meeting and pick up
    postProductMeetingPickupSave: builder.mutation({
      query: (data) => ({
        url: "product-meeting-pickup-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // endpoint for product meeting and pickup remove
    postProductMeetingPickupRemove: builder.mutation({
      query: (data) => ({
        url: "product-meeting-pickup-remove",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // endpoint for adding attraction
    postProductAttractionSave: builder.mutation({
      query: (data) => ({
        url: `product-attractions-save/${data?.lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),


    // endpoint for product attraction remove
    postProductAttractionRemove: builder.mutation({
      query: (data) => ({
        url: `product-attractions-remove/${data?.lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // endpoint for saving product tour details
    postProductTourDetailsSave: builder.mutation({
      query: (data) => ({
        url: "product-tour-detail-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // endpoint for getting age group  categories
    getProductAgeGroupsCategorys: builder.query({
      query: () => ({
        url: "product-age-groups-categories",
        method: "GET",
      }),
    }),

    // endpoint for adding add groups into product
    postProductPriceAgeGroupsSave: builder.mutation({
      query: (data) => ({
        url: "product-price-age-groups-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // endpoint for getting guided languages
    getProductGuidedLanguages: builder.query({
      query: () => ({
        url: "product-guided-languages",
        method: "GET",
      }),
    }),

    // endpoint for adding add guided languages into product
    postProductGuidedLanguagesSave: builder.mutation({
      query: (data) => ({
        url: "product-guided-languages-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // add exclusion/inclusion for product
    postProductExclusionInclusionSave: builder.mutation({
      query: (data) => ({
        url: `product-inclusion-exclusion-save/${data?.lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // add exclusion/inclusion for product
    postProductExclusionInclusionRemove: builder.mutation({
      query: (data) => ({
        url: `product-inclusion-exclusion-remove/${data?.lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // get product accessibilities
    getProductAccessibilities: builder.query({
      query: () => ({
        url: "product-accessibilities",
        method: "GET",
      }),
    }),

    // post product accessibilities save
    postProductAccessibilitiesSave: builder.mutation({
      query: (data) => ({
        url: "product-accessibilities-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),
  }),
});

export const {
  usePostProductMeetingPickupSaveMutation,
  usePostProductMeetingPickupRemoveMutation,
  usePostProductAttractionSaveMutation,
  usePostProductAttractionRemoveMutation,
  usePostProductTourDetailsSaveMutation,
  useGetProductAgeGroupsCategorysQuery,
  usePostProductPriceAgeGroupsSaveMutation,
  useGetProductGuidedLanguagesQuery,
  usePostProductGuidedLanguagesSaveMutation,
  usePostProductExclusionInclusionSaveMutation,
  usePostProductExclusionInclusionRemoveMutation,
  useGetProductAccessibilitiesQuery,
  usePostProductAccessibilitiesSaveMutation,
} = productContentSlice;
